import React from 'react';
import PropTypes from 'prop-types';

import StyledTextarea from './components/styled-textarea/';
import ValidatedTextarea from './components/validated/';

const Textarea = ({ badgeIndex, disabled, id, isValidated, validationType, value, onChange, parse }) => {
    return isValidated ? (
        <ValidatedTextarea badgeIndex={badgeIndex} type={validationType} value={value} parse={parse} />
    ) : (
        <StyledTextarea disabled={disabled} id={id} value={value} onChange={onChange} />
    );
};

Textarea.propTypes = {
    badgeIndex: PropTypes.string,
    disabled: PropTypes.bool,
    id: PropTypes.string,
    isValidated: PropTypes.bool,
    parse: PropTypes.bool,
    onChange: PropTypes.func,
    validationType: PropTypes.oneOf(['error', 'success', 'warning', 'missing']),
    value: PropTypes.string,
};

export default Textarea;
